import CollapsibleTable from "../../components/CollapsableTable";

interface Props {
  data: any;
}
export const UnsatisfiedCategoryTable = (props: Props) => {
  const { data } = props;
  const rows = data.map((v: any) => {
    return createData(
      v.title,
      v.required_count,
      v.curriculum_version,
      v.option_group_credit,
      v.competencies
    );
  });

  function createData(
    title: string,
    required_count: number,
    curriculum_version: number,
    option_group_credit: number,
    competencies: any
  ) {
    return {
      title,
      required_count,
      curriculum_version,
      option_group_credit,
      competencies,
    };
  }

  return (
    <div style={{ marginBottom: 15 }}>
      <CollapsibleTable rows={rows} createData={createData} />
    </div>
  );
};
